import React from "react";
import RiskSettingsIcon from "./RiskSettings.svg?react";

export function getRiskSettingsIcon() {
    return React.createElement(RiskSettingsIcon);
}

export const allOptionId = "all";

// Keeps the "All" option mutually exclusive with specific selections.
export function resolveSelectionWithAll(values: string[], currentSelection: string[]) {
    const allWasJustSelected = values.includes(allOptionId) && !currentSelection.includes(allOptionId);
    return allWasJustSelected ? [allOptionId] : values.filter((id) => id !== allOptionId);
}
